import React, { FC } from 'react';
import { Container, Row } from 'react-bootstrap';
import ClTitle from 'components/clientComp/clTitle';

import './ClContact.scss';
import { contactData } from 'configs/contactData';
import { ClContactForm } from 'components/clientComp/clContact/components';

const ClContact: FC = () => {
  return (
    <Container fluid className="cl-contact">
      <ClTitle titleNumber={'04'} title={'Contact'} subTitle={'Get In Touch'} />
      <Row className="cl-contact-container">
        <div className="cl-contact-left">
          {contactData.map((val, index) => (
            <div
              data-aos="zoom-in"
              data-aos-duration="1000"
              key={index}
              className="contact-item"
            >
              {val.icon}
              <p className="social-name">{val.socialName}</p>
              <p className="social-id">{val.userId}</p>
              <a
                href={
                  val.socialName === 'Email'
                    ? `mailto:${val.contactUrl}`
                    : val.contactUrl
                }
                target="_blank"
                className="send-message"
                rel="noreferrer"
              >
                Send a message
              </a>
            </div>
          ))}
        </div>
        <div className="cl-contact-right">
          <ClContactForm />
        </div>
      </Row>
    </Container>
  );
};

export default ClContact;
